import { makeStyles } from "@fluentui/react-components";

const useStyles = makeStyles({
  "@global": {
    // // Direct global targeting of FluentUI Tab indicator
    // ".fui-Tab": {
    //   "&::before": {
    //     display: "none !important",
    //     width: "0 !important",
    //     content: "none !important",
    //     backgroundColor: "transparent !important",
    //     borderLeft: "none !important",
    //   },
    // },
    // Target the specific class that might be causing the blue line
    // ".f1way5bb, .f1vjpng2, .f1051ucx, .fqa318h, .fdp32p8, .fdzul7t": {
    //   borderLeft: "none !important",
    //   "&::before": {
    //     display: "none !important",
    //   },
    // },
    // Override FluentUI Tab indicator CSS variables at the document level
    ":root": {
      "--fui-Tab__indicator--color": "transparent !important",
      "--fui-Tab__indicator--width": "0px !important",
    },
    // Direct body rule to catch all tabs
    // "body .fui-Tab[aria-selected='true']::before": {
    //   display: "none !important",
    //   width: "0 !important",
    //   content: "none !important",
    //   backgroundColor: "transparent !important",
    //   borderLeft: "none !important",
    // },
  },
  TabHeader: {
    background: "#F8F8F8",
    color: "#242424",
    justifyContent: "unset",
    minWidth: 16,
    "&:hover": {
      background: "#f5f5f5",
      borderLeft: "none",
    },
    "&[data-selected=true]": {
      background: "#ffffff",
      borderLeft: "none",
    },
    "&::before, &::after": {
      display: "none !important",
      width: "0 !important",
      content: "none !important",
      backgroundColor: "transparent !important",
      borderLeft: "none !important",
    },
    "& .fui-Tab__indicator": {
      display: "none !important",
    },
  },
  TabListCustom: {
    "& .fui-TabList": {
      "--tab-indicator-color": "transparent !important",
      "--tab-indicator-width": "0 !important",
    },
    "& .fui-Tab": {
      "&::before, &::after": {
        display: "none !important",
        width: "0 !important",
        content: "none !important",
        backgroundColor: "transparent !important",
        borderLeft: "none !important",
      },
    },
    "& [role='tab']:hover": {
      background: "#f5f5f5 !important",
      borderLeft: "none !important",
      "&::before, &::after": {
        display: "none !important",
      },
    },
    "& [role='tab'][aria-selected='true']": {
      background: "#ffffff !important",
      borderLeft: "none !important",
      "&::before, &::after": {
        display: "none !important",
      },
    },
    "& .f1way5bb, & .f1vjpng2, & .f1051ucx": {
      borderLeft: "none !important",
      "&::before, &::after": {
        display: "none !important",
      },
    },
  },
  ContentHeader: {
    display: "grid",
    gridTemplateColumns: "1fr auto",
    minWidth: 100,
    minHeight: 36,
  },
  TextHeader: {
    fontFamily: "Arial",
    fontSize: 9,
    fontWeight: 700,
    textAlign: "left",
    minWidth: 16,
  },
  AddText: {
    fontFamily: "Arial",
    fontSize: "8pt",
    fontWeight: 400,
    marginRight: "2px",
    verticalAlign: "middle",
  },
  HangingButton: {
    fontFamily: "Arial",
    fontSize: "9pt",
    fontWeight: 400,
    marginRight: "2px",
  },
});

export default useStyles;
